import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';

import { Spinner } from '../../../index';

const SubmitButton = ({
  disabled, submitting, defaultLabel, submittingLabel, onSubmit,
}) => {
  let buttonText = defaultLabel;
  let buttonIcon;
  if (submitting) {
    buttonText = submittingLabel;
    buttonIcon = <Spinner className="mr-2 float-left" />;
  }

  return (
    <Button
      color="primary"
      className="btn-asure-submit d-flex align-items-center"
      onClick={(e) => {
        e.preventDefault();
        onSubmit();
      }}
      disabled={disabled}
    >
      {buttonIcon}
      <FormattedMessage id={buttonText} />
    </Button>
  );
};

SubmitButton.defaultProps = {
  disabled: false,
  submitting: false,
};

SubmitButton.propTypes = {
  disabled: PropTypes.bool,
  submitting: PropTypes.bool,
  defaultLabel: PropTypes.string.isRequired,
  submittingLabel: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default SubmitButton;



// WEBPACK FOOTER //
// ./src/components/Forms/Components/SubmitButton/SubmitButton.jsx